exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-fit[data-v-6b956451]{-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center}.video-controls[data-v-6b956451]{background:#999}", ""]);

// exports
